import { render, staticRenderFns } from "./_ExportButton.vue?vue&type=template&id=4054115e"
import script from "./_ExportButton.vue?vue&type=script&lang=js"
export * from "./_ExportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports